import { render, staticRenderFns } from "./report-jifenjiahe.vue?vue&type=template&id=5f32a19f&scoped=true&"
import script from "./report-jifenjiahe.vue?vue&type=script&lang=ts&"
export * from "./report-jifenjiahe.vue?vue&type=script&lang=ts&"
import style0 from "./report-jifenjiahe.vue?vue&type=style&index=0&id=5f32a19f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f32a19f",
  null
  
)

export default component.exports